const unwrapPromiseSettledResult = <T>(result: PromiseSettledResult<T>, defaultValue?: T): T | undefined => {
    if (result.status === 'fulfilled') {
        return result.value;
    }
    return defaultValue;
};

const resolveAllSettledObject = async <T>(object: Record<string, Promise<T>>): Promise<Record<string, T>> => {
    const keys = Object.keys(object);
    const values = Object.values(object);

    const results = await Promise.allSettled(values);

    return keys.reduce<Record<string, T>>((acc, key, i) => {
        if (results[i].status === 'fulfilled') {
            acc[key] = results[i].value;
        }
        return acc;
    }, {});
};

export const PromiseHelpers = {
    unwrapPromiseSettledResult,
    resolveAllSettledObject,
};
